import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../../../../../../base/icons/icon/index.js";
import * as S from "./styled.js";
const MessageError = ({ error , literals  })=>/*#__PURE__*/ _jsx(S.MessageWrapper, {
        "data-testid": "MessageError",
        children: /*#__PURE__*/ _jsxs(S.Message, {
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    className: "nico-info"
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: error.errorMessage ?? literals?.messageError ?? literals?.errorComponentMessage
                })
            ]
        })
    });
export default MessageError;

//# sourceMappingURL=index.js.map